module.exports = __webpack_public_path__ + "img/graphic-talent.606ffd06.svg";